export default function(context, options) {
    if (context == null) return options.fn(this);
    return options.inverse(this);
}